export const assignSubtypePriority = (product: any) => {
  const productSubType = product.productSubType

  return {
    ...product,
    subTypePriority: (() => {
      switch (true) {
        case productSubType === "Screen Protectors":
          return 1
        case productSubType === "Cases":
          return 2
        default:
          return 0
      }
    })(),
  }
}
